import axios from '@/libs/api.request'

/**
 * 添加日常快报用户
 */
export const addDayReportUser = (day_report_id, user_ids) => {
    const data ={
        "day_report_id": day_report_id,
        "user_ids": user_ids
    }
    return axios.request({
        url: '/api/admin/dayreportuser/save',
        data,
        method: 'post'
    })
}

/**
 * 发送日常快报
 */
export const sendDayReportUser = (day_report_id) => {
    const data ={
        "day_report_id": day_report_id
    }
    return axios.request({
        url: '/api/admin/dayreportuser/send',
        data,
        method: 'post'
    })
}